import { defaultTo } from 'ramda';
import { IAutoProlongInfo } from '../../../redux/reducers';
import { IAutoProlongInfoSchema } from '../../../repositories/monolith-python/entities/AutoProlongInfoSchema';

export function mapAutoProlongInfo(autoProlongInfo?: IAutoProlongInfoSchema | null): IAutoProlongInfo {
  const { isAvailable, hintText, tooltipText } = autoProlongInfo || {};

  return {
    isAvailable: defaultTo(false, isAvailable),
    hintText: defaultTo('', hintText),
    tooltipText: defaultTo('', tooltipText),
  };
}
